import { useState, useRef } from "react";
import { Button, Label, Modal, ModalBody, ModalFooter, ModalHeader, TextInput } from "flowbite-react";
import { HiPlus } from "react-icons/hi";
import { toast } from "react-toastify";
import { createPlaylist } from "../../services/radio";

const AddPlaylistModal = ({ onCreated }: any) => {
  const [isOpen, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [title, setTitle] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  const handleSubmit = async () => {
    if (!title.trim()) return;
    setIsSubmitting(true);
    try {
      await createPlaylist({ title, is_default: isDefault });
      toast.success("Playlist created successfully!");
      onCreated();
      setOpen(false);
      setTitle("");
      setIsDefault(false);
    } catch (e) {
      toast.error("Failed to create playlist");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div ref={rootRef}>
      <Button color="primary" onClick={() => setOpen(true)}>
        <div className="flex items-center gap-x-3">
          <HiPlus className="text-xl" />
          Add Playlist
        </div>
      </Button>
      <Modal
        onClose={() => setOpen(false)}
        show={isOpen}
        root={rootRef.current ?? undefined}
      >
        <ModalHeader>Create Playlist</ModalHeader>
        <ModalBody>
          <Label htmlFor="playlist-title">Title</Label>
          <TextInput
            id="playlist-title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Playlist title"
          />
          <div className="mt-4 flex items-center gap-2">
            <label className="relative inline-flex cursor-pointer items-center">
              <input
                type="checkbox"
                className="peer sr-only"
                checked={isDefault}
                onChange={(e) => setIsDefault(e.target.checked)}
              />
              <div className="peer h-6 w-11 rounded-full bg-gray-200 after:absolute after:left-[2px] after:top-[2px] after:size-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-blue-600 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-hidden peer-focus:ring-4 peer-focus:ring-blue-300 dark:border-gray-600 dark:bg-gray-700 dark:peer-focus:ring-blue-800"></div>
              <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                Default playlist
              </span>
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" disabled={isSubmitting} onClick={handleSubmit}>
            {isSubmitting ? "Creating..." : "Create"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AddPlaylistModal;
